export default {
  customButtonPages: [2],
  showBannerPages: [],
  underListPages: [],
  tabelaMateriaisPage: null,
  modelProcesso: {},
  currentMaterialModelProcesso: {},
  pageList: [
    {
      title: 'Leitura dos materiais',
      subItems: [
        { title: 'Responsável retirada' },
      ],
    },
  ],
};
